export const CardDT = {
	card: {
		css: ({ dt }) => `
              .p-card__no-shadow { box-shadow: none; }
              .p-card__no-content-padding .p-card-body { padding: 0; }

              .p-card__padding--8-24 .p-card-body { padding: var(--p-padding-xs) var(--p-padding-ml); }
              .p-card__padding--12-16 .p-card-body { padding: var(--p-padding-s) var(--p-padding-sm); }
              .p-card__padding--16-24 .p-card-body { padding: var(--p-padding-sm) var(--p-padding-ml); }
              .p-card__padding--16-24-24-24 .p-card-body { padding: var(--p-padding-sm) var(--p-padding-ml) var(--p-padding-ml) var(--p-padding-ml); }
              .p-card__padding--12-16-24-16 .p-card-body { padding: var(--p-padding-s) var(--p-padding-sm) var(--p-padding-ml) var(--p-padding-sm); }
              .p-card__padding--24-24-48-24 .p-card-body { padding: var(--p-padding-ml) var(--p-padding-ml) var(--p-padding-xl) var(--p-padding-ml); }
              .p-card__padding--24 .p-card-body { padding: var(--p-padding-ml); }

              .p-card__rect-padding--0 .p-card-body { padding: 0; }
              .p-card__rect-padding--8 .p-card-body { padding: var(--p-padding-xs); }
              .p-card__rect-padding--16 .p-card-body { padding: var(--p-padding-sm); }
              .p-card__rect-padding--24 .p-card-body { padding: var(--p-padding-ml); }

              .p-card__full-size { height: 100%; }
              .p-card__full-size .p-card-body { height: 100%; }
              .p-card__full-size .p-card-content {
                  height: 100%;
                  display: flex;
                  flex-direction: column;
               }
              .p-card__padding-top-0 .p-card-body {
                  padding-top: 0;
              }
              .p-card__body-gap-4 .p-card-body {
                  gap: .25rem;
              }
              .p-card__body-gap-4 .p-card-body {
                  gap: .25rem;
              }
              .p-card__hide-title .p-card-title {
                display: none;
              }
              .p-card__hide-subtitle .p-card-subtitle {
                display: none;
              }
        `,
	},
};
